'use client';

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import FirebaseAuth from '@/components/FirebaseAuth';
import SandboxAuth from '@/components/SandboxAuth';
import { isClerkAuth } from '@/lib/auth/authConfig';
const redirectPath = '/dashboard';

/** Sign-in page with multi-provider authentication */
export default function SignInPage() {
  const $ = _c(5);
  const params = useSearchParams();
  let t0;
  if ($[0] !== params) {
    t0 = params.get("redirect") ?? redirectPath;
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const redirectUrl = t0;
  if (isClerkAuth) {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <FirebaseAuth />;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] !== redirectUrl) {
    t1 = <SandboxAuth redirectUrl={redirectUrl} />;
    $[3] = redirectUrl;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}